module.exports = __webpack_public_path__ + "img/ecp-dagger.0fe56633.svg";